import React from "react";

export default function CarrotUp() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="11.639" height="7.187">
			<path d="M1.368 7.187 5.82 2.745l4.451 4.442 1.368-1.368-3.736-3.736L5.819-.001 0 5.818Z" fill="#142541" />
		</svg>
	);
}
